import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import type { ColumnDef } from '@tanstack/react-table'
import { useMemo } from 'react'

import { Cell, DataTable, useDataTable } from '@/components/block/data-table'
import { Page } from '@/components/layout/page'
import { CardExtendTable } from '@/components/ui/card-extend'

import { itemOutletApi } from '@/features/inventory/api/item-outlet-api'
import type { ItemOutletDto } from '@/features/inventory/dto/item-outlet-dto'

import { useAuth } from '@/lib/auth'
import { formatAccountingNumber, toIdr } from '@/libs/utils/format'

export const Route = createFileRoute('/_app/inventory/outlet/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <ItemTable />
    </Page>
  )
}

function ItemTable() {
  const outletId = useAuth().outlet.oId
  const { data, isLoading } = useQuery({
    ...itemOutletApi.list.query({ params: { outletId } }),
  })

  const columns = useMemo(() => getColumns(), [])
  const table = useDataTable({
    columns,
    isLoading,
    data: data?.data.items ?? [],
  })

  return (
    <CardExtendTable title='Daftar Outlet'>
      <DataTable.Root table={table}>
        <DataTable.Table />
        <DataTable.Pagination />
      </DataTable.Root>
    </CardExtendTable>
  )
}

function getColumns(): ColumnDef<ItemOutletDto>[] {
  return [
    {
      accessorKey: 'item.name',
      header: 'Bahan Baku',
      minSize: 180,
      cell: ({ row }) => (
        <Cell.Link
          from={Route.fullPath}
          to='/inventory/master/$id/update'
          params={{ id: row.original.imId }}
        >
          {row.original.item.name}
        </Cell.Link>
      ),
    },
    {
      accessorKey: 'stock',
      header: 'Stock',
      cell: ({ row }) => {
        const stock = formatAccountingNumber(row.original.stock)
        const unit = row.original.item.units[0]?.unit
        return <Cell.Text text={`${stock} ${unit}`} />
      },
    },
    // {
    //   accessorKey: 'sum.start',
    //   header: 'Start',
    //   cell: ({ row }) => <Cell.Text text={row.original.sum.start} />,
    // },
    // {
    //   accessorKey: 'sum.end',
    //   header: 'End',
    //   cell: ({ row }) => <Cell.Text text={row.original.sum.end} />,
    // },
    // {
    //   accessorKey: 'sum.in',
    //   header: 'In',
    //   cell: ({ row }) => <Cell.Text text={row.original.sum.in} />,
    // },
    // {
    //   accessorKey: 'sum.out',
    //   header: 'Out',
    //   cell: ({ row }) => <Cell.Text text={row.original.sum.out} />,
    // },
    {
      accessorKey: 'item.units[0].sku',
      header: 'SKU',
      cell: ({ row }) => <Cell.Text text={row.original.item.units[0]?.sku} />,
    },
    {
      accessorKey: 'item.units[0].unit',
      header: 'Harga & Satuan',
      cell: ({ row }) => {
        const { item, avgCost } = row.original
        const unit = item.units[0]?.unit
        return (
          <Cell>
            <p>{toIdr(avgCost)}</p>&nbsp;
            <p>/{unit}</p>
          </Cell>
        )
      },
    },
    {
      accessorKey: 'updatedAt',
      header: () => 'Updated At',
      cell: ({ row }) => <Cell.Date date={row.original.updatedAt} />,
    },
  ]
}
